import React, { useState, useEffect, useReducer } from "react";
import Dashboard from "../../Dasboard/Dashboard";
import MUIDataTable from "mui-datatables";
import { domain } from "../../../Urls/Services/Api_urls";
import Swal from "sweetalert2";
import { Edit, Trash, Restart } from "iconoir-react";

const escapeHtml = (value) =>
  String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

const apiError = (body) => {
  if (typeof body.msg === "string") return body.msg;
  if (body.msg) return Object.values(body.msg).flat().join(" ");
  return body.error;
};

export default function CausalAnul() {
  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0);
  const token = window.sessionStorage.getItem("token");
  const [campaings, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);


  //2 - Función para mostrar los datos con fetch
  useEffect(() => {
    const getData = () => {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      myHeaders.append("Content-Type", "application/json");

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
      fetch(domain + "/portal_causal/?all=True", requestOptions)
        .then((data) => data.json())
        .then((data) => {
          setCampaigns(data.data);
        })
        .finally(() => setLoading(false));
    };
    getData();
  }, [ignored, token]);

  const changeCausalState = (id, activate) =>
    Swal.fire({
      title: activate ? "¿Activar causal?" : "¿Desactivar causal?",
      text: activate
        ? "La causal se volverá a mostrar en los listados y podrá ser utilizada."
        : "Dejará de mostrarse en los listados de causales y no podrá ser usada.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: activate ? "Activar" : "Desactivar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#30125d",
      cancelButtonColor: "#6c757d",
      reverseButtons: true,
    }).then((confirmation) => {
      if (!confirmation.isConfirmed) return;

      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);

      let request;
      if (activate) {
        headers.append("Content-Type", "application/json");
        request = fetch(`${domain}/portal_causal/${id}/`, {
          method: "PUT",
          headers,
          body: JSON.stringify({ state: true }),
          redirect: "follow",
        });
      } else {
        request = fetch(`${domain}/portal_causal/${id}`, {
          method: "DELETE",
          headers,
          redirect: "follow",
        });
      }

      return request
        .then(async (response) => {
          if (!response.ok) {
            const body = await response.json().catch(() => ({}));
            throw new Error(apiError(body) || "No se pudo cambiar el estado");
          }
          forceUpdate();
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: activate ? "Causal activada" : "Causal desactivada",
            showConfirmButton: false,
            timer: 2500,
          });
        })
        .catch((error) =>
          Swal.fire("No se pudo completar la acción", error.message, "error")
        );
    });

  const columns = [
    {
      name: "id",
      label: "Acciones",
      options: {
        viewColumns: false,
        filter: false,
        setCellProps: () => ({ style: { minWidth: 110 } }),
        customBodyRender: (value, tableMeta, updateValue) => {
          const isActive = tableMeta.rowData[7] !== false;
          return (
            <div
              style={{
                display: "flex",
                gap: "0.75rem",
                justifyContent: "center",
              }}
            >
                <div
                  title={
                    isActive
                      ? "Editar causal"
                      : "Activa la causal para poder editarla"
                  }
                  aria-label="Editar causal"
                  aria-disabled={!isActive}
                  style={{
                    cursor: isActive ? "pointer" : "not-allowed",
                    opacity: isActive ? 1 : 0.35,
                  }}
                  onClick={() => {
                    if (!isActive) return;
                    var myHeaders = new Headers();
                    myHeaders.append("Authorization", `Bearer ${token}`);
                    myHeaders.append("Content-Type", "application/json");

                    var requestOptions = {
                      method: "GET",
                      headers: myHeaders,
                      redirect: "follow",
                    };

                    fetch(
                      domain + "/portal_causal/" + tableMeta.rowData[0] + "/",
                      requestOptions
                    )
                      .then((response) => response.json())
                      .then((result) =>
                        !result.data ? Swal.fire(
                          "No se pudo cargar la causal",
                          typeof result.msg === "string" ? result.msg : "Intenta de nuevo.",
                          "error"
                        ) : Swal.fire({
                          title: "Editar causal",
                          width: 560,
                          customClass: {
                            popup: "causal-modal",
                            title: "causal-title",
                            htmlContainer: "causal-container",
                            actions: "causal-actions",
                            confirmButton: "causal-btn-primary",
                            cancelButton: "causal-btn-secondary",
                          },
                          html: `
                            <style>
                              .causal-modal { padding: 1.5rem 0 1.25rem; border-radius: 5px; }
                              .causal-title { font-size: 1.25rem; font-weight: 600; padding: 0 1.5rem; text-align: center; }
                              .causal-container { margin: 0.75rem 0 0; padding: 0; }
                              .causal-actions { width: 100%; justify-content: center; gap: 0.75rem; padding: 0 1.5rem; margin-top: 1.25rem; }
                              .causal-btn-primary { background: #30125d !important; border-radius: 8px !important; padding: 0.6rem 1.25rem !important; font-size: 0.95rem !important; }
                              .causal-btn-secondary { background: #eceff1 !important; color: #37474f !important; border-radius: 8px !important; padding: 0.6rem 1.25rem !important; font-size: 0.95rem !important; }
                              .causal-form { text-align: left; padding: 0 1.5rem; }
                              .causal-section { padding: 1rem 0; border-top: 1px solid #e5e7eb; }
                              .causal-section:first-child { border-top: 0; padding-top: 0; }
                              .causal-label { display: block; font-size: 0.9rem; font-weight: 600; color: #263238; margin-bottom: 0.25rem; }
                              .causal-hint { display: block; font-size: 0.8rem; color: #607d8b; margin-top: 0.35rem; line-height: 1.3; }
                              .causal-readonly { display: flex; align-items: center; justify-content: space-between; gap: 0.75rem; background: #f4f5f7; border-radius: 8px; padding: 0.6rem 0.85rem; color: #37474f; font-size: 0.95rem; }
                              .causal-chip { font-size: 0.7rem; font-weight: 600; color: #607d8b; background: #e3e7ea; border-radius: 999px; padding: 0.15rem 0.55rem; white-space: nowrap; }
                              .causal-option { display: flex; align-items: center; justify-content: flex-start; gap: 0.75rem; border: 1px solid #d5d9de; border-radius: 8px; padding: 0.7rem 0.85rem; margin-top: 0.5rem; cursor: pointer; transition: border-color .15s, background .15s; }
                              .causal-option:hover { border-color: #30125d; }
                              .causal-option.is-checked { border-color: #30125d; background: #f3eefb; }
                              .causal-option:focus-within { outline: none; }
                              .causal-option:has(input:focus-visible) { border-color: #30125d; }
                              .causal-option input { width: 1.15rem; height: 1.15rem; accent-color: #30125d; cursor: pointer; }
                              .causal-option-title { display: block; text-align: left; font-size: 0.95rem; font-weight: 600; color: #263238; }
                              .causal-option-desc { display: block; font-size: 0.8rem; color: #607d8b; }
                              .causal-textarea { width: 100%; resize: vertical; border: 1px solid #d5d9de; border-radius: 8px; padding: 0.6rem 0.85rem; font-size: 0.95rem; font-family: inherit; }
                              .causal-textarea:focus { outline: 2px solid #30125d; outline-offset: 0; border-color: #30125d; }
                              .causal-textarea:disabled { background: #f4f5f7; color: #90a4ae; cursor: not-allowed; }
                              .causal-counter { float: right; }
                            </style>
                            <form class="causal-form">
                              <div class="causal-section">
                                <span class="causal-label">Nombre</span>
                                <div class="causal-readonly">
                                  <span>${escapeHtml(result.data.name_cause)}</span>
                                </div>
                              </div>
                              <div class="causal-section">
                                <span class="causal-label">Visible para</span>
                                <span class="causal-hint">Elige a qué grupos de usuarios se les muestra esta causal.</span>
                                <label class="causal-option">
                                  <input type="checkbox" id="potential_client" ${result.data.potential_client ? "checked" : ""}>
                                  <span class="causal-option-title align-left">Cliente potencial</span>
                                </label>
                                <label class="causal-option">
                                  <input type="checkbox" id="sale_service" ${result.data.sale_service ? "checked" : ""}>
                                  <span class="causal-option-title align-left">Venta</span>
                                </label>
                                <label class="causal-option">
                                  <input type="checkbox" id="customer_selectable" ${result.data.customer_selectable ? "checked" : ""}>
                                  <span class="causal-option-title align-left">Seleccionable por el cliente</span>
                                </label>
                              </div>
                              <div class="causal-section">
                                <label class="causal-label" for="customer_description">Mensaje para el cliente</label>
                                <textarea id="customer_description" class="causal-textarea" rows="4" placeholder="Ej: No deseo continuar con mi solicitud" ${result.data.customer_selectable ? "" : "disabled"}>${escapeHtml(result.data.customer_description)}</textarea>
                                <span class="causal-hint">
                                  <span id="customer_description_hint"></span>
                                  <span class="causal-counter" id="customer_description_counter"></span>
                                </span>
                              </div>
                            </form>
                          `,
                          confirmButtonText: "Guardar cambios",
                          confirmButtonColor: "#30125d",
                          showCancelButton: true,
                          cancelButtonText: "Cancelar",

                          didOpen: () => {
                            const selectable = document.getElementById("customer_selectable");
                            const description = document.getElementById("customer_description");
                            const hint = document.getElementById("customer_description_hint");
                            const counter = document.getElementById("customer_description_counter");

                            const refresh = () => {
                              description.disabled = !selectable.checked;
                              hint.textContent = selectable.checked
                                ? "Es lo que el cliente verá. Usa un lenguaje claro y sencillo."
                                : "Marca «Seleccionable por el cliente» para escribir este mensaje.";
                              document
                                .querySelectorAll(".causal-option")
                                .forEach((option) =>
                                  option.classList.toggle(
                                    "is-checked",
                                    option.querySelector("input").checked
                                  )
                                );
                            };

                            selectable.addEventListener("change", refresh);
                            description.addEventListener("input", refresh);
                            document
                              .querySelectorAll(".causal-option input")
                              .forEach((input) => input.addEventListener("change", refresh));
                            refresh();
                          },

                          preConfirm: () => {
                            const customerDescription = document
                              .getElementById("customer_description")
                              .value.trim();
                            const customerSelectable =
                              document.getElementById("customer_selectable").checked;

                            if (customerSelectable && !customerDescription) {
                              Swal.showValidationMessage(
                                "Escribe una descripción breve para que el cliente pueda seleccionar esta causal"
                              );
                              return false;
                            }

                            var myHeaders = new Headers();
                            myHeaders.append("Authorization", `Bearer ${token}`);
                            myHeaders.append("Content-Type", "application/json");

                            var requestOptions = {
                              method: "PUT",
                              headers: myHeaders,
                              body: JSON.stringify({
                                potential_client:
                                  document.getElementById("potential_client").checked,
                                sale_service:
                                  document.getElementById("sale_service").checked,
                                customer_selectable: customerSelectable,
                                ...(customerSelectable && {
                                  customer_description: customerDescription,
                                }),
                                state: result.data.state,
                              }),
                              redirect: "follow",
                            };

                            return fetch(
                              domain +
                              "/portal_causal/" +
                              tableMeta.rowData[0] +
                              "/",
                              requestOptions
                            )
                              .then(async (response) => {
                                if (!response.ok) {
                                  const respuesta = await response
                                    .json()
                                    .catch(() => ({}));
                                  const detalle = respuesta.msg
                                    ? Object.values(respuesta.msg).flat().join(" ")
                                    : respuesta.error;
                                  throw new Error(
                                    detalle || "Hay errores en el registro"
                                  );
                                }
                                forceUpdate();
                                return true;
                              })
                              .catch((error) => {
                                Swal.showValidationMessage(
                                  `Request failed: ${error}`
                                );
                              });
                          },
                        }).then((resultado) => {
                          if (resultado.isConfirmed) {
                            Swal.fire({
                              toast: true,
                              position: "top-end",
                              icon: "success",
                              title: "Causal actualizada",
                              showConfirmButton: false,
                              timer: 2500,
                            });
                          }
                        })
                      );
                  }}
                >
                  <Edit style={{ color: "#5e5e5e" }} />
                </div>
                <div
                  title={isActive ? "Desactivar causal" : "Activar causal"}
                  aria-label={isActive ? "Desactivar causal" : "Activar causal"}
                  style={{ cursor: "pointer", textAlign: "center" }}
                  onClick={() =>
                    changeCausalState(tableMeta.rowData[0], !isActive)
                  }
                >
                  {isActive ? (
                    <Trash style={{ color: "#5e5e5e" }} />
                  ) : (
                    <Restart style={{ color: "#5e5e5e" }} />
                  )}
                </div>
            </div>
          );
        },
      },
    },
    {
      name: "id",
      label: "ID",
    },
    {
      name: "name_cause",
      label: "Causal de anulación",
      options: {
        setCellProps: () => ({ style: { minWidth: 320 } }),
      },
    },
    {
      name: "customer_description",
      label: "Descripción para el cliente",
      options: {
        setCellProps: () => ({ style: { minWidth: 280 } }),
        customBodyRender: (value) =>
          value ? (
            value
          ) : (
            <span style={{ color: "#90a4ae", fontStyle: "italic" }}>
              Sin descripción
            </span>
          ),
      },
    },
    ...[
      ["potential_client", "Cliente potencial"],
      ["sale_service", "Venta"],
      ["customer_selectable", "Seleccionable por el cliente"],
    ].map(([name, label]) => ({
      name,
      label,
      options: {
        setCellProps: () => ({ style: { minWidth: 60, textAlign: "left" } }),
        setCellHeaderProps: () => ({ style: { textAlign: "left" } }),
        // compensa el margen negativo del botón de ordenar para alinear el título con el badge
        customHeadLabelRender: ({ label }) => (
          <span style={{ display: "inline-block", paddingLeft: 0, textAlign: "left" }}>
            {label}
          </span>
        ),
        filterOptions: {
          renderValue: (value) => (value ? "Sí" : "No"),
        },
        customBodyRender: (value) => (
          <span
            style={{
              display: "inline-block",
              padding: "0.15rem 0.6rem",
              borderRadius: 999,
              fontSize: "0.75rem",
              fontWeight: 600,
              color: value ? "#1b5e20" : "#546e7a",
              background: value ? "#e8f5e9" : "#eceff1",
            }}
          >
            {value ? "Sí" : "No"}
          </span>
        ),
      },
    })),
    {
      name: "state",
      label: "Estado",
      options: {
        setCellProps: () => ({ style: { minWidth: 100 } }),
        filterOptions: {
          renderValue: (value) => (value ? "Activa" : "Inactiva"),
        },
        customBodyRender: (value) => (
          <span
            style={{
              display: "inline-block",
              padding: "0.15rem 0.6rem",
              borderRadius: 999,
              fontSize: "0.75rem",
              fontWeight: 600,
              color: value ? "#1b5e20" : "#546e7a",
              background: value ? "#e8f5e9" : "#eceff1",
            }}
          >
            {value ? "Activa" : "Inactiva"}
          </span>
        ),
      },
    },
  ];

  const options = {
    rowsPerPage: 15,
    rowsPerPageOptions: [10, 15, 25, 50, 100],
    // print: false,
    fixedHeader: true,
    tableBodyHeight: "calc(100vh - 300px)",
    tableBodyMaxHeight: "calc(100vh - 300px)",
    selectableRows: "none",
    downloadOptions: {
      filename: "causales_anulacion.csv",
      separator: ",",
    },
    textLabels: {
      body: {
        noMatch: loading
          ? "Cargando causales..."
          : "No hay causales para mostrar",
        toolTip: "Ordenar",
        columnHeaderTooltip: (column) => `Ordenar por ${column.label}`,
      },
      pagination: {
        next: "Siguiente",
        previous: "Anterior",
        rowsPerPage: "Filas por página:",
        displayRows: "de",
      },
      toolbar: {
        search: "Buscar",
        downloadCsv: "Descargar CSV",
        print: "Imprimir",
        viewColumns: "Ver columnas",
        filterTable: "Filtrar datos",
      },
      filter: {
        all: "Todo",
        title: "FILTROS",
        reset: "LIMPIAR",
      },
      viewColumns: {
        title: "Mostrar Columnas",
        titleAria: "Mostrar/ocultar columnas de la tabla",
      },
      selectedRows: {
        text: "fila(s) seleccionadas",
        delete: "Eliminar",
        deleteAria: "Eliminar filas",
      },
    },
    responsive: "standard",
    setTableProps: () => ({ style: { minWidth: 1100 } }),
  };

  return (
    <div>
      <Dashboard
        MInicio={""}
        Msolicitudes={""}
        Mservicios={""}
        Mcompra={""}
        Mcunyompra={""}
        Mempaquetar={""}
        Mcpotenciales={""}
        Madminportal={""}
        Mcampaña={""}
        Mtv={"active"}
      >
      <section style={{ padding: "1rem" }}>
        <h3 style={{ padding: "2rem" }}>Administrar causales</h3>
        <div className="flex flex-col gap-4">
          <MUIDataTable
            columns={columns}
            data={campaings}
            options={options}
          />
        </div>
      </section>
      </Dashboard>
    </div>
  );
}

// ## Summary
// This code is a React component that displays a table of campaigns for a TV grid. It fetches the campaign data from an API and allows the user to add, edit, and delete campaigns. The component uses the MUIDataTable library to render the table with custom options and columns. It also includes a form for adding and editing campaigns, which is displayed in a modal dialog using the Swal library.

// ## Example Usage
// ```javascript
// <Tvgrilla />
// ```

// ## Code Analysis
// ### Inputs
// - None
// ___
// ### Flow
// 1. The component initializes state variables using the useState and useReducer hooks.
// 2. It fetches the campaign data from the API using the useEffect hook and stores it in the "campaigns" state variable.
// 3. The component defines the columns and options for the MUIDataTable.
// 4. It renders the Dashboard component and the MUIDataTable component with the campaign data and options.
// 5. When the user clicks on the edit button in a row, a modal dialog is displayed with a form pre-filled with the campaign data. The user can edit the form fields and submit the form to update the campaign.
// 6. When the user clicks on the delete button in a row, the corresponding campaign is deleted from the API.
// ___
// ### Outputs
// - The component renders a table of campaigns for a TV grid, allowing the user to add, edit, and delete campaigns.
// ___
